<emp-header />

<main>
  <emp-side-menu />

  <div class="content" cdkScrollable>
    <router-outlet />
  </div>
</main>
